import { StorageExplorerSettings } from "@/features/storage/useStorage";
import { Dispatch, SetStateAction, useEffect, useRef } from "react";
import { GetFoldersResponseType } from "./useGetFolders";
import { GetFilesResponseType } from "./useGetFiles";
import { t } from "@/lib/localization";

export const useSyncInitialData = ({
    settings,
    setSelectedFolders,
    setSelectedFiles,
    changeParentFolder,
}: {
    settings: StorageExplorerSettings;
    setSelectedFolders: Dispatch<
        SetStateAction<GetFoldersResponseType["data"]>
    >;
    setSelectedFiles: Dispatch<SetStateAction<GetFilesResponseType["data"]>>;
    changeParentFolder: (
        folder: GetFoldersResponseType["data"][0] | null
    ) => void;
}) => {
    useEffect(() => {
        if (settings.files?.initialSelectedFiles) {
            setSelectedFiles(settings.files.initialSelectedFiles);
        }
    }, [setSelectedFiles, settings.files?.initialSelectedFiles]);

    useEffect(() => {
        if (settings.folders.initialSelectedFolders) {
            setSelectedFolders(settings.folders.initialSelectedFolders);
        }
    }, [setSelectedFolders, settings.folders.initialSelectedFolders]);

    // Runs once so a later settings change can't yank the user back to the
    // initial folder. Passing null loads the root folder's preferences.
    const appliedInitialParentFolder = useRef(false);
    useEffect(() => {
        if (appliedInitialParentFolder.current) return;
        appliedInitialParentFolder.current = true;
        changeParentFolder(settings.folders.initialParentFolder ?? null);
    }, [changeParentFolder, settings.folders.initialParentFolder]);
};
